<!--
  - Copyright (c) 2021. Michael Clovis
  - This program is free software: you can redistribute it and/or modify
  -     it under the terms of the GNU Affero General Public License as published by
  -     the Free Software Foundation, either version 3 of the License, or
  -     (at your option) any later version.
  -
  -     This program is distributed in the hope that it will be useful,
  -     but WITHOUT ANY WARRANTY; without even the implied warranty of
  -     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  -     GNU Affero General Public License for more details.
  -
  -     You should have received a copy of the GNU Affero General Public License
  -     along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<template>
  <td class="col-3">
    <div v-for="jt in jobTypes.keys()" class="row rectangle " :key="jt">
      <div class="col-12">
        {{ jt }}

      </div>
      <div class="col-12">
        {{ jobTypes.get(jt).hours }}  Hours <span v-show="showPay"> &nbsp;${{ jobTypes.get(jt).pay.toFixed(2) }} </span>
      </div>
      <div class="col-12">
        {{ jobTypes.get(jt).timeCardHours}} Time Clock Hours
      </div>
    </div>
  </td>
</template>

<script>
import {TimeCard} from "@/classes/TimeCard";

export default {
  name: "ScheduleTotalItem",
  watch: {
    moment: {
      deep: true,
      handler() {
        this.setRota();
      },
    }
  },
  computed: {
    rota() {
      return this.$store.state.appointments;
    },
    users() {
      return this.$store.state.users;
    },
    jobs() {
      return this.$store.state.jobs;
    },
  },
  methods: {
    setRota() {
      // this.dRota = this.rota.filter(elem=>{
      //   return elem.isOnSameDayAs(this.moment);
      // });
      // console.log("setting dRota")
      //console.log(this.dRota);
      this.jobTypes = new Map();
      for (let idx = 0; idx < this.dRota.length; idx++) {
        let hoursAndPay = {};

          hoursAndPay.job = this.dRota[idx].job
          hoursAndPay.hours = this.dRota[idx].halfHours / 2;
          hoursAndPay.timeCardHours = new TimeCard(this.dRota[idx].validateCheckin,this.dRota[idx].clockOut).getHoursWorked()



        // find the user to get the pay rate
        let userIndex = this.users.findIndex((elem) => {
          return elem.id === this.dRota[idx].User.id
        })
        if (userIndex > -1) {
          //console.log("User index: "+ userIndex);
          let jobIdx = this.jobs.findIndex((elem) => {
            return elem.name === this.dRota[idx].job;
          });
          if (jobIdx > -1) {
            let payRate = this.users[userIndex].jobs.get(this.jobs[jobIdx].id);
            hoursAndPay.pay = hoursAndPay.hours * payRate;

          } else {
            hoursAndPay.pay = 0;
          }

        } else {
          hoursAndPay.pay = 0;
        }
        //console.log(this.$store.state.loggedInUser)

        if (this.jobTypes.has(this.dRota[idx].job) ) {
          console.log("here")
          let prevHourAndPay = this.jobTypes.get(this.dRota[idx].job);
          hoursAndPay.hours += prevHourAndPay.hours;
          hoursAndPay.pay += prevHourAndPay.pay;
          hoursAndPay.timeCardHours = prevHourAndPay.timeCardHours

          if(this.dRota[idx].User.id === this.$store.state.loggedInUser.id || this.$store.state.loggedInUser.isAdmin) {
            this.jobTypes.set(this.dRota[idx].job, hoursAndPay);
          }
        } else {
          // console.log("Appt user:")
          // console.log(this.dRota[idx].User)
          // console.log( this.dRota[idx].User === this.$store.state.loggedInUser)
          if(this.dRota[idx].User.id === this.$store.state.loggedInUser.id || this.$store.state.loggedInUser.isAdmin) {
            this.jobTypes.set(this.dRota[idx].job, hoursAndPay);
          }
        }

      }
    }
  },
  created() {
    this.setRota();
  },
  data() {
    return {
      // dRota: [],
      jobTypes: new Map(),
    }
  },
  props: {
    moment: {
      type: Object,
      required: true,
    },
    showPay: {
      type: Boolean,
      required: true,
    },
    dRota: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.rectangle {
  margin: 3px;
  background-color: white;
  border: black 3px solid;
}
</style>
